export default class ContentHandler {
  constructor({
    settings    = null,
  } = {}) {

    console.log('ContentHandler constructor...');
    this.cache    = {}
    this.token = '';
    this.user = null;
    this.hooks = null;
    this.url = '';
    this.image_path = '';
    this.app_path = '';
  }

   _log(type,source,message,data='')
  {
    let _message = 'fw-workbench/ContentHandler::'+source+'- '+message;
    switch(type)
    {
       case "debug":
         console.debug(_message,data);
        break;
      case "warning":
         console.warn(_message,data);
      case "info":
         console.info(_message,data);
        break;
      case "error":
         console.error(_message,data);
        break;
      default:
          console.log(_message,data);
    }
  }

  async _load()
  {

    try
    {
      let headers = {};
      // Set user
      if(this.user && this.user.is_loggedin())
      {
        headers['Authorization'] = 'Bearer '+this.user.token;
        headers['Content-Type'] = 'application/json';
      }

      this.dsbClient = new DatastoreBuilderClient({
              endpoint: this.url,
              headers: headers,
              bootstrap: '',
              hooks: this.hooks
      });
      let init = await this.dsbClient.init();
    }
    catch(ex)
    {
      this.user.is_offline('maintenance');
      console.error("ContentHandler: Cannot connect to DatastoreBuilderClient", ex);
    }
    return true;

  }


  async init(url,hooks,user)
  {
    if(typeof user === 'object' && user !== null && ('token' in user))
    {
      this.user = user;
    }
    else
    {
      console.error('user passed is not a UserHandler!',user.constructor);
    }
    this.hooks = hooks;
    this.url = url;
    return await this._load();
  }

  processQuery(query,params={},mode=true)
  {
    let _this = this;
    const getQueryParams = function (query,_params={},mode=false)
    {
      let params = {};
      new URLSearchParams(query).forEach((value, key) => {
        let decodedKey = decodeURIComponent(key);
        let decodedValue = decodeURIComponent(value);

        if(mode == "process")
        {
          switch(decodedValue)
          {
            case "{{today}}":
              decodedValue = _this.format_date('now','Y-m-d');
              break;
            case "{{today_timestamp}}":
              decodedValue = _this.format_date('now','timestamp_y-m-d');
              break;
            case "{{tomorrow}}":
              decodedValue = _this.format_date('tomorrow','Y-m-d');
              break;
            default:
              break;
          }
        }

        // This key is part of an array
        if (decodedKey.endsWith("[]")) {
          decodedKey = decodedKey.replace("[]", "");
          params[decodedKey] || (params[decodedKey] = []);
          params[decodedKey].push(decodedValue);
          // Just a regular parameter
        } else {
          params[decodedKey] = decodedValue;
        }
      });
      if(mode=='diff')
      {
        let diff={};
        for(let _param_key in _params)
        {
          if(_param_key in params)
          {
            if(params[_param_key] == _params[_param_key])
            {
              if(!('same' in diff))
              {
                diff.same={};
              }
              diff.same[_param_key]=params[_param_key];
            }
            else
            {
              if(!('changed' in diff))
              {
                diff.changed={};
              }
              diff.changed[_param_key]={};
              diff.changed[_param_key].from=params[_param_key];
              diff.changed[_param_key].to=_params[_param_key];
            }
          }
          else
          {
            if(!('missing' in diff))
            {
              diff.missing={};
            }
            diff.missing[_param_key]=_params[_param_key];
          }
        }
        return diff;
      }
      else
      {
        // Update with _params
        for(let _param_key in _params)
        {
            params[_param_key] = _params[_param_key];
        }

        if(mode=='cleanse')
        {
          // Remove missing
          for(let param_key in params)
          {
            if(!(param_key in _params))
            {
              delete params[param_key];
            }
          }
        }
      }
      return params;
    };
    if(mode=='diff')
    {
      if(typeof params !== 'object')
      {
        params =getQueryParams(params);
      }
      return getQueryParams(query,params,mode)
    }
    else if(mode=='object')
    {
      return getQueryParams(query,params,mode);
    }
    else
    {
      let thisQueryString=[];
      let url_params = getQueryParams(query,params,mode);
      for(let aUrl_paramsKey in url_params)
      {
        if(Array.isArray(url_params[aUrl_paramsKey]))
        {
          for(let i=0;i<url_params[aUrl_paramsKey].length;i++)
            {
              thisQueryString.push(aUrl_paramsKey+'[]='+url_params[aUrl_paramsKey][i]);
            }
        }
        else
        {
          thisQueryString.push(aUrl_paramsKey+'='+url_params[aUrl_paramsKey]);
        }
      };
      return thisQueryString.join('&');
      //let url_params = new URLSearchParams(getQueryParams(query,params,mode));
      //return url_params.toString();
    }
  };

  async get(target,query,allow_offline=false,retry=true)
  {
    let is_offline = await this.user.is_offline();
    if(is_offline)
    {
      if(!allow_offline)
      {
        this._log('error','get','Offline without allow_offline',allow_offline);
        return false;
      }
    }
    else
    {
      if(this.user)
      {
        if(!await this.user.is_loggedin('',true))
        {
          throw {code:'401', message: 'Not logged in and login refresh failed!'};
        }
      }
    }

    let result = false;
    try
    {
      result = await this.dsbClient.get(target,query);
    }
    catch(ex)
    {
      result = ex;
    }


    if(typeof result === 'object' && result !== null && ('code' in result))
    {
      if(result.code==401)
      {
        if(is_offline)
        {
          throw {code: 500, message: '401 despite being offline... how?',data:result};
        }
        else
        {
          if(retry)
          {
            this._log('debug','get','1st try 401-ed, trying again...');
            await  this.user.renew();
            await this.user._refresh_profile_from_token(true);
            return this.get(target,query,allow_offline,false);
          }
          else
          {
            await this.user.run_login_redirect('change_layout');
            throw {code:'401', message: 'Not logged in and login refresh failed!'};
          }
        }
      }
      else if(result.code>300)
      {
        throw {code: result.code, message: result.message,data:result};
      }
      else
      {
        return result;
      }
    }
    else
    {
      throw {code:500,message:'result not an object',result};
    }


    return false;
  }

  applyFilter(name,value)
  {
    return this.dsbClient.applyFilter(name, value );
  }


  format_date(timestamp, format='default',show_time=false)
  {
    var date = null;

    var return_date = '';

    const calculateTimimg = function (d){
      let months = 0, years = 0, days = 0, weeks = 0, total = d;
      while(d){
          if(d >= 365){
            years++;
            d -= 365;
          }else if(d >= 30){
            months++;
            d -= 30;
          }else if(d >= 7){
            weeks++;
            d -= 7;
          }else{
            days++;
            d--;
          }
      };
      return {
          years, months, weeks, days, total
      };
    };

    switch(timestamp)
    {
      case "now":
      case "today":
         date = new Date();
         break;
      case "tomorrow":
        date = new Date();
        date.setDate(date.getDate() + 1);
      default:
        if(!isNaN(timestamp))
        {
          date = new Date(timestamp * 1000);
        }
        else
        {
          // Assume mysql timestamp
          /**
          console.debug(timestamp);
          let t = timestamp.split(/[- :]/);
          console.debug(t);
          date = new Date(Date.UTC(t[0], t[1]-1, t[2], t[3], t[4], t[5]));
          console.debug(date);
          */
          date = new Date(timestamp);
        }
        break;
    }

    switch(format)
    {
      case "timestamp_y-m-d":
          return_date = new Date(date.getFullYear()+"-"+(("0" + (date.getMonth() + 1)).slice(-2))+"-"+(("0" + (date.getDate())).slice(-2))).getTime()/1000;
          break;
      case "Y-m-d":
          return_date = date.getFullYear()+"-"+(("0" + (date.getMonth() + 1)).slice(-2))+"-"+(("0" + (date.getDate())).slice(-2));
          break;
      case "since":
          //calculate time difference
         var time_difference = new Date().getTime() - date.getTime();

         //calculate days difference by dividing total milliseconds in a day
         let dwmy = calculateTimimg(Math.trunc(time_difference / (1000 * 60 * 60 * 24)));

         let _return_date = [];

         if(('years' in dwmy) && dwmy.years>0)
         {
           _return_date.push(dwmy.years+' year'+(dwmy.years == 1?'':'s'));
         }

         if(('months' in dwmy) && dwmy.months>0)
         {
           _return_date.push(dwmy.months+' month'+(dwmy.months == 1?'':'s'));
         }

         if(('weeks' in dwmy) && dwmy.weeks>0)
         {
           _return_date.push(dwmy.weeks+' week'+(dwmy.weeks == 1?'':'s'));
         }

         if(('days' in dwmy) && dwmy.days>0)
         {
           _return_date.push(dwmy.days+' day'+(dwmy.days == 1?'':'s'));
         }

         return_date = dwmy;

         return_date.string = _return_date.join(", ");

         break;
      default:
        const nth = function(d) {
          if (d > 3 && d < 21) return 'th';
          switch (d % 10) {
            case 1:  return "st";
            case 2:  return "nd";
            case 3:  return "rd";
            default: return "th";
          }
        }

        var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var year = date.getFullYear();
        var month = months[date.getMonth()];
        var day = date.getDate();

        // Hours part from the timestamp
        var hours = date.getHours();
        // Minutes part from the timestamp
        var minutes = "0" + date.getMinutes();

        // Will display time in YYYY/MM/DD 10:30:23 format
        if(show_time)
        {
          return_date = day+''+nth(day)+' '+month+' '+year+' at '+hours + ':' + minutes.substr(-2);
        }
        else
        {
          return_date = day+''+nth(day)+' '+month+' '+year;
        }
    }

    return return_date;
  }

}


